
import { supabase } from "@/integrations/supabase/client";
import { handleServiceError, withErrorHandling } from "../utils/errorHandling";

/**
 * Service for saving search history
 */
export const searchMutationService = {
  /**
   * Save a search query to the database
   * @param searchQuery The search query to save
   */
  saveSearch: withErrorHandling(
    async (searchQuery: string): Promise<void> => {
      // Get the current user
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user?.id) {
        throw new Error("User must be authenticated to save searches");
      }

      const { error } = await supabase
        .from('recipe_searches')
        .insert([
          { 
            user_id: user.id, // Now properly using UUID
            search_query: searchQuery 
          }
        ]);
      
      if (error) {
        throw error;
      }
    },
    "Failed to save search"
  ),
};
